/** Languages offered by the whole platform (web + API messages). English is the default. */
export const LANGS = ['en', 'fr'] as const;
export type Lang = (typeof LANGS)[number];
export const DEFAULT_LANG: Lang = 'en';

/** Storage key (localStorage + cookie) shared by every Nexora demo app. */
export const LANG_KEY = 'nx-lang';

/** Intl locale used to format dates, numbers and money. */
export const LOCALES: Record<Lang, string> = { en: 'en-CA', fr: 'fr-CA' };

/** A text available in both languages. */
export interface Localized {
  en: string;
  fr: string;
}

export function parseLang(v: unknown): Lang | null {
  return v === 'en' || v === 'fr' ? v : null;
}

/** Reads `nx-lang` from a raw Cookie header (or document.cookie). */
export function langFromCookie(cookie: string | null | undefined): Lang | null {
  const m = /(?:^|;\s*)nx-lang=([^;]+)/.exec(cookie ?? '');
  return m ? parseLang(decodeURIComponent(m[1])) : null;
}

/** "11:00" -> "11 h 00" (fr) or "11:00 a.m." (en). */
export function formatHour(hhmm: string, lang: Lang): string {
  if (lang === 'fr') return hhmm.replace(':', ' h ');
  const [h, m] = hhmm.split(':').map(Number);
  const d = new Date(Date.UTC(2000, 0, 1, h, m));
  return new Intl.DateTimeFormat(LOCALES.en, { hour: 'numeric', minute: '2-digit', timeZone: 'UTC' }).format(d);
}
